import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, forkJoin } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import * as R from 'ramda';
import { MenuApiService } from '../menu-api.service';
import { MenuStoreService } from '../menu-store.service';
import {LocationSetsActions} from '@emm/menu/store/location-sets/location-sets.actions';

@Injectable({
    providedIn: 'root'
})
export class MenuLocationSetsEffects {

    loadLocationsByParent$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LocationSetsActions.loadLocationsByParent),
            switchMap(({ parentTag }) =>
                this.api.getAllLocationSetsByTag(parentTag).pipe(
                    map((locationSets) =>
                        LocationSetsActions.loadLocationsByParentSuccess({ locationSets })
                    ),
                    catchError(({ error }) =>
                        of(LocationSetsActions.loadLocationsByParentFailure({ error }))
                    )
                )
            )
        )
    );

    loadAllByScope$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LocationSetsActions.loadAllByScope),
            withLatestFrom(this.store.queryLocationSetTypes.onlyParents$),
            switchMap(([_, locationSetTypes]) =>
                forkJoin(
                    locationSetTypes.map(locationSetType =>
                        this.api.getAllLocationSetsByTag(locationSetType.tag)
                    )
                ).pipe(
                    map(R.flatten),
                    map(locationSets => LocationSetsActions.loadAllByScopeSuccess({ locationSets })),
                    catchError(error => of(LocationSetsActions.loadAllByScopeFailure({ error })))
                )
            )
        )
    );


    constructor(
        private actions$: Actions,
        private api: MenuApiService,
        private store: MenuStoreService
    ) {}

}
